/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React, { useEffect } from 'react';
import {
    object, shape, string, array, func,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';
import Grid from '@material-ui/core/Grid';
import { format } from 'date-fns';
import { useUIDSeed } from 'react-uid';
import { bindActionCreators } from 'redux';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import GraphqlBreadcrumbs from '../GraphqlCommonComponents/GraphqlBreadcrumbs/GraphqlBreadcrumbs';
import customBreakpoints from '../../../helpers/customBreakpoints';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import LinkOrATag from '../GraphqlCommonComponents/LinkOrATag/LinkOrATag';
import { trackEvent as track } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    container: {
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downSmall,
            margin: '0 auto',
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downMedium,
            margin: '0 auto',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: 1440,
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: 1440,
            margin: '0 auto',
        },
        padding: 15,
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            padding: 0,
        },
    },
    breadcrumbAndFilterContainer: {
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            display: 'none',
        },
    },
    imocMain: {
        width: '100%',
        backgroundColor: theme.palette.common.white,
        padding: '20px 20px',
        boxSizing: 'border-box',
        overflow: 'auto',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.grey5}`,
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            borderBottom: 0,
            backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
    },
    imocHeaderContainer: {
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            maxWidth: '100%',
            flexBasis: '100%',
            textAlign: 'center',
        },
    },
    imocHeader: {
        borderRight: `1px solid ${theme.palette.grey5}`,
        margin: '0px 30px 0 0',
        color: theme.palette.imocTitleColor,
        fontSize: 24,
        fontWeight: 700,
        display: 'block',
        '& p': {
            margin: 0,
        },
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            margin: 0,
            color: theme.palette.common.white,
            border: `1px solid ${theme.palette.common.white}`,
            padding: '25px',
            fontWeight: 500,
        },
    },
    imocDescriptionContainer: {
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            display: 'none',
        },
    },
    coupanMain: {
        maxWidth: 1350,
        margin: 'auto',
        marginTop: 30,
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            marginTop: 5,
        },
    },
    coupanInner: {
        width: '80%',
        margin: 'auto',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        textAlign: 'center',
        '& strong': {
            '& p': {
                margin: '0',
                fontSize: 14,
                color: theme.palette.contentColor,
            },
            '& span': {
                color: theme.palette.cardTitleColor,
                padding: '0px 5px',
            },
        },
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            width: '90%',
        },
    },
    coupanCard: {
        border: `2px dashed ${theme.palette.grey2}`,
        width: 325,
        margin: '15px',
        padding: '15px 0',
        '& a': {
            textDecoration: 'none',
        },
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            width: '45%',
            margin: '5px',
        },
        [theme.breakpoints.down(330)]: {
            padding: '5px',
        },
    },
    expiration: {
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            display: 'flex',
            flexDirection: 'column',
        },
    },
    title: {
        color: theme.palette.cardTitleColor,
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'center',
        '& p': {
            margin: 0,
        },
        '& h1, h2, h3, h4, h5, h6': {
            margin: 0,
            fontSize: 18,
        },
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            fontSize: 13,
        },
    },
    description: {
        fontSize: 14,
        color: theme.palette.contentColor,
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            fontSize: 12,
        },
    },
    backToTop: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        cursor: 'pointer',
        textDecoration: 'underline',
        fontSize: 14,
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            fontSize: 16,
        },
    },
    bottomContent: {
        fontSize: 14,
        '& a': {
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
        '& h2': {
            fontSize: 16,
            fontWeight: 600,
            margin: '10px 0px',
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            width: '90%',
            margin: '5px auto',
            textAlign: 'center',
        },
    },
    ctaButton: {
        color: '#000',
        textAlign: 'center',
        fontWeight: 'bold',
        padding: '8px',
        border: `1px solid ${theme.palette.grey7}`,
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            padding: '8px 0',
        },
    },
    promoImg: {
        width: '100%',
    },
    termLink: {
        color: theme.palette.contentColor,
        fontSize: 14,
        '& a': {
            color: theme.palette.cardTitleColor,
            paddingLeft: 5,
        },
        '& sup': {
            fontSize: 14,
            verticalAlign: 'text-bottom',
        },
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            width: '80%',
            margin: '12px auto',
        },
    },
    imocDescription: {
        '& p': {
            margin: 0,
        },
    },
    coupanContainer: {
        padding: 10,
    },
});
const scrollTop = () => {
    if (typeof window !== 'undefined') {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }
};
const PromocodeBlock = ({
    classes, block, brand, page, trackEvent,
}) => {
    if (!block) {
        return null;
    }
    let seo;
    const header_title = block.header_title || '';
    const header_copy = block.header_copy || '';
    const page_blocks = block.page_blocks || [];
    const seed = useUIDSeed();
    const breadCrumb = block?.seo?.breadcrumb;

    useEffect(() => {
        trackEvent({
            eventCategory: block?.tracking?.tracking_event_category || 'Landing Page',
            eventAction: block?.tracking?.tracking_event_action || 'Promotions',
            eventLabel: block?.tracking?.tracking_event_label || 'Page Visit',
        });
    }, []);

    if (block.seo) {
        seo = JSON.parse(JSON.stringify(block.seo));
    } else {
        seo = {};
    }
    seo.og = [];
    seo.og.push(
        { property: 'og:title', content: seo.page_title || '' },
        { property: 'og:type', content: 'website' },
        { property: 'og:image', content: 'https://www.1800flower-usa.com/api/fl-cdn/wcsstore/RAPIDStorefrontAssetStore/images/flowers-com.jpg' },
        { property: 'og:description', content: seo.meta_description || '' },
        { property: 'og:url', content: `https://www.${brand.domain}.com${page.path || ''}` },
    );
    return (
        <>
            {
                seo?.seo_searchable
                    ? (
                        <GraphqlSeoHeadTags seoData={seo} />
                    ) : null
            }

            <div className={classes.container}>
                <div className={classes.breadcrumbAndFilterContainer}>
                    <GraphqlBreadcrumbs breadCrumbArray={breadCrumb} />
                </div>
                <div className={classes.imocMain}>
                    <Grid container>
                        <Grid xs={3} item className={classes.imocHeaderContainer}>
                            <h1 className={classes.imocHeader}>
                                <ReactMarkdown source={header_title} escapeHtml={false} />
                            </h1>
                        </Grid>
                        <Grid xs={9} item className={classes.imocDescriptionContainer}>
                            <ReactMarkdown className={classes.imocDescription} source={header_copy} escapeHtml={false} />
                        </Grid>
                    </Grid>
                </div>
                <div className={classes.coupanMain}>
                    <Grid container className={classes.container}>
                        {page_blocks?.map((cards) => {
                            if (Object.keys(cards)[0] === 'promo_card') {
                                const promoCard = cards?.promo_card || {};
                                const title = promoCard?.title || '';
                                const description = promoCard?.description || '';
                                const promo_code = promoCard?.promo_code || '';
                                const expires = promoCard?.expires || '';
                                const get_discount_link = promoCard?.get_discount_link || {};
                                const get_discount_color = promoCard?.get_discount_color || '';
                                const image = promoCard?.image || '';
                                const isDate = Date.parse(expires);
                                return (
                                    <Grid key={seed(cards)} title={title} className={classes.coupanCard} item>
                                        <LinkOrATag href={get_discount_link?.href}>
                                            <div className={classes.coupanInner}>
                                                <div className={classes.coupanContainer}>
                                                    <img className={classes.promoImg} src={image?.url} alt={get_discount_link?.title || 'Promo Code Title'} />
                                                    <div className={classes.title}>
                                                        <ReactMarkdown source={title} escapeHtml={false} />
                                                    </div>
                                                    <p className={classes.description}>{description}</p>
                                                    <strong>
                                                        {promo_code && <p>Promo Code:<span>{promo_code}</span> </p>}
                                                        {expires && (
                                                            <p className={classes.expiration}> Code Expires:<span>{(isDate) ? format(new Date(expires), 'MM/dd/yyyy') : expires}</span>
                                                            </p>
                                                        )}
                                                    </strong>
                                                </div>
                                                <div className={classes.ctaButton} style={{ color: get_discount_color }}>{get_discount_link?.title || 'Get Discount'}</div>
                                            </div>
                                        </LinkOrATag>
                                    </Grid>
                                );
                            }
                            if (Object.keys(cards)[0] === 'disclaimer') {
                                return (
                                    <Grid className={classes.bottomContent}>
                                        <ReactMarkdown source={cards?.disclaimer?.copy} escapeHtml={false} renderers={{ paragraph: 'span' }} />
                                        <span className={classes.backToTop} role="presentation" onClick={scrollTop}>
                                            Back to top
                                        </span>
                                    </Grid>
                                );
                            }
                            return null;
                        })}
                    </Grid>
                </div>
            </div>
        </>
    );
};

PromocodeBlock.propTypes = {
    classes: object.isRequired,
    block: shape({
        header_title: string.isRequired,
        header_copy: string.isRequired,
        promo_cards: array.isRequired,
    }).isRequired,
    brand: object.isRequired,
    page: shape({
        path: string.isRequired,
    }).isRequired,
    trackEvent: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

const enhance = compose(
    connect(null, mapDispatchToProps),
    withRouter,
    withStyles(styles),
);

export default enhance(PromocodeBlock);
